module.exports = __webpack_public_path__ + "static/media/cambridge.629e8c37.jpg";